import { render, staticRenderFns } from "./PrintSuite.vue?vue&type=template&id=34f3fb65"
import script from "./PrintSuite.vue?vue&type=script&lang=js"
export * from "./PrintSuite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f3fb65')) {
      api.createRecord('34f3fb65', component.options)
    } else {
      api.reload('34f3fb65', component.options)
    }
    module.hot.accept("./PrintSuite.vue?vue&type=template&id=34f3fb65", function () {
      api.rerender('34f3fb65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrintSuite/PrintSuite.vue"
export default component.exports